export default __webpack_public_path__ + "static/media/pantry1-afterC-480w.bb5aaa02.webp";